<template>
  <div>
    <div class="AllAboutUS" id="__nuxt">
      <div id="__layout">
        <div>
          <div class="container">
            <div class="content">
              <div class="about__container">
                <div class="about__content-container">
                  <div class="about__content">
                    <div class="about__head">
                      <div class="about__head-content">
                        <h1>درباره <span>شمال املاک</span></h1>
                      </div>
                    </div>
                    <p
                      class="about__about"
                      v-html="$store.state.c_set.about_us"
                    ></p>
                    <div class="about__values">
                      <p
                        class="about__values-description"
                        v-html="$store.state.c_set.our_value"
                      ></p>
                      <!-- <table class="about__table">
                        <thead>
                          <tr>
                            <th class="about__table-title">ارزش‌ها</th>
                            <th class="about__table-description">توضیحات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="title">
                              <div>روابط شبکه‌ ای</div>
                            </td>
                            <td>
                              ما به دنبال برقراری روابط میان فردی فراتر از سمت،
                              سطح و واحد جهت آشنایی با تجارب و تخصص همدیگر و
                              افزایش سرمایه اجتماعی سازمان هستیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>تعهد حرفه ‌ای</div>
                            </td>
                            <td>
                              ما به دنبال ارزیابی تعهد، در تمامی ابعاد آن بوده و
                              به دنبال ارزش افزوده دو طرفه برای سازمان و
                              همکارانمان هستیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>توانمندسازی</div>
                            </td>
                            <td>
                              ما به دنبال ارتقای دائمی دانش و مهارت‌ ها در ابعاد
                              رفتاری و شغلی و بهینه‌ ازی توانایی‌ در راستانی
                              نیازهای سازمان هستیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>توسعه و تعالی</div>
                            </td>
                            <td>
                              ما به دنبال تسهیل تعالی سازمان هستیم تا آنکه زمینه
                              تعالی واحدهای سازمانی و خود را فراهم سازیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>تیم‌سازی بهینه</div>
                            </td>
                            <td>
                              ما برای ایده‌ های خود به دنبال تیمی خواهیم بود تا
                              آن را به عمل رسانده و تبدیل به محصول کنیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>کار با حال خوش</div>
                            </td>
                            <td>
                              تمامی کارها برای لذت بردن از انجام و از آن مهم تر
                              برای لذت دیدن حال خوش همکاران انجام می‌ شود.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>حرمت کلام</div>
                            </td>
                            <td>
                              ما برای انجام وظایف‌مان منتظر کلمات هستیم، نه
                              دستورالعمل و نامه رسمی، درست مانند یک خانواده.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>
                                حساسیت و پاسخگویی به نیاز مشتریان و کارکنان
                              </div>
                            </td>
                            <td>
                              تمامی اعضای سازمان شنوا و بینای همدیگر و مشتریان
                              هستند تا کوچکترین خواسته ‌های آن ها هم بی‌جواب
                              نماند.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>ایده و خلق راهکار</div>
                            </td>
                            <td>
                              ما به دنبال نظراتی هستیم که در آن حوزه تخصص و
                              تجربه داریم و می توانیم راهی برای رفع مشکلات یا
                              توسعه قوت ‌ها ارائه کنیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>روحیه پیشرویی</div>
                            </td>
                            <td>
                              ما هیچگاه متوقف نخواهیم شد و تمامی همه چیز را می
                              ‌خواهیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>رهبری تسهیل‌گرانه</div>
                            </td>
                            <td>
                              رهبران سازمان مدیران و سرپرستانی هستند که از تجارب
                              و حمایت ‌های خود برای تسهیل و پیشبرد آن استفاده
                              می‌کنند.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>سازمان دوستانه</div>
                            </td>
                            <td>
                              سازمان ما قبیله ‌ای است که اعضای آن در جامعه
                              ملاحظه ر و هواخواه آن، کار می‌ن د.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>عاملیت</div>
                            </td>
                            <td>
                              تمامی اعضای سازمان خود را مسئول انجام و عدم انجام
                              کارهای خود در تمام مدت زندگی کاری‌شان می ‌دانند.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>با هم کار کردن</div>
                            </td>
                            <td>
                              ما کارهایی که می‌ توانیم باهم انجام دهیم را به
                              صورت انفرادی انجام نداده و از با هم بودن لذت می‌
                              بریم
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>گفت و شنود</div>
                            </td>
                            <td>
                              ما، در سازمان منتظر نمی نشینیم تا مشکلات حاد یا
                              خوبی‌ها خود به خود از بین بروند، بلکه به سرعت
                              پیگیر رفع یا توسعه آن‌ها خواهیم بود، همچنین گفته
                              ها را می‌شنویم و به دنبال تفسیر نیستیم و خود نیز
                              منظورمان را واضح و بدون تفسیر بیان می کنیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title">
                              <div>مربی گری</div>
                            </td>
                            <td>
                              رهبران سازمان اعضای تیم‌های خود را برای انجام
                              وظایف‌شان رشد داده و بستر انجام وظایف آن ها را
                              فراهم می ‌کنیم.
                            </td>
                          </tr>
                          <tr>
                            <td class="title last-td">
                              <div>همدلی</div>
                            </td>
                            <td class="last-td">
                              ما با منطق، تحلیل و تصمیم عمل می نماییم و آن را با
                              کمک و یاری یکدیگر به ثمر می‌ سانیم.
                            </td>
                          </tr>
                        </tbody>
                      </table> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
.about__content {
  padding-bottom: 54px;
}
</style>
